module.exports = __webpack_public_path__ + "img/currency.18e750cc.png";